






















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class IconDiscover extends Vue {
  @Prop() type;

  get colors() {
    return this.type === "disabled"
      ? ["#CCCCCC", "#EEEEEE", "#999999"]
      : ["#67BFFF", "#BAE2FF", "#169CFE"];
  }
}
export default IconDiscover;
